import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../fluxStandardAction'
import { BankError } from '#modules/Bank/Bank.types'

export type SignalRConnectAction = FluxStandardAction<
	'transactionClientApp/signalR/connect',
	null
>

export type SignalRConnectSucceededAction = FluxStandardAction<
	'transactionClientApp/signalR/connectSucceeded',
	null
>

export type SignalRConnectFailedAction =
	FluxStandardFailureAction<'transactionClientApp/signalR/connectFailed'>

export function signalRConnect(): SignalRConnectAction {
	return {
		type: 'transactionClientApp/signalR/connect',
		payload: null,
	}
}

export function signalRConnectSucceeded(): SignalRConnectSucceededAction {
	return {
		type: 'transactionClientApp/signalR/connectSucceeded',
		payload: null,
	}
}

export function signalRConnectFailed(
	error: BankError,
): SignalRConnectFailedAction {
	return {
		type: 'transactionClientApp/signalR/connectFailed',
		error: true,
		payload: error,
	}
}
